export const EQUIPMENT_KINDS = [
  'Bolster',
  'Chime',
  'Mat',
  'Recording',
  'Sauna Bench',
  'Sound Bowl',
  'Support',
] as const;

export type EquipmentKindT = typeof EQUIPMENT_KINDS[number];
